import baseUrl from "../config/baseUrl";

const editDocumentDetails = async ({
  token,
  user_id,
  case_number,
  document_id,
  document_desc,
  document_title,
  category,
  automation_source,
  record_name,
  record_id,
  assigned_user_id,
}) => {
  const formData = new FormData();
  formData.append("user_id", user_id);
  formData.append("case_number", case_number);
  formData.append("document_id", document_id);
  formData.append("document_title", document_title);
  formData.append("document_desc", document_desc);
  formData.append("category", category);
  formData.append("automation_source", automation_source);
  formData.append("record_name", record_name);
  formData.append("record_id", record_id);
  formData.append("assigned_user_id", assigned_user_id);

  try {
    const response = await fetch(`${baseUrl}/apireact/update_documents`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default editDocumentDetails;
